export default __webpack_public_path__ + "static/generalFryingPan1-ff1952393a350de49a2825cf6679e05e.jpg";